<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Relatório de Pendências por Período'">
          <template v-slot:preview>
            <v-row class="mb-5">
              <v-col cols="4">
                <v-select :loading="carregandoGrupos" :items="grupos" label="Grupo" item-text="nome" item-value="id"
                  v-model="filtro.grupoID" :rules="[rules.required]" required>
                  <template template v-slot:selection="{ item }">
                    <div>
                      <v-icon>{{ item.icone }}</v-icon>
                      <span>{{ ` ${item.nome}` }}</span>
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div>
                      <v-icon>{{ item.icone }}</v-icon>
                      <span>{{ ` ${item.nome}` }}</span>
                    </div>
                  </template>
                </v-select>
              </v-col>
              <v-col>
                <v-switch v-model="filtro.listarApenasEmpresasVigentes">
                  <template #label>Apenas Empresas Vigentes </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col align-self="start">
                <download-excel :ref="'download-relatorio-monitor-pendencias'" :data="relatorioXls.pendenciasExportar"
                  :name="relatorioXls.nomeArquivo">
                  <v-btn :disabled="filtro.grupoID == 0" @click="carregarMonitor" color="primary" large>Pesquisar</v-btn>
                </download-excel>
              </v-col>
              <v-progress-linear v-if="loading" indeterminate color="indigo"></v-progress-linear>
            </v-row>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <v-alert border="left" color="secondary" v-if="carregando">
      <v-progress-circular indeterminate color="green"></v-progress-circular>
      &nbsp;&nbsp;Estamos carregando as pendências. Aguarde alguns instantes por
      favor.
    </v-alert>
    <v-divider></v-divider>
    <div v-if="monitorPendencias.length == 0 && pesquisado && !carregando">
      <v-alert dense outlined type="info">
        Nenhuma pendência encontrada</v-alert>
    </div>
    <div v-if="monitorPendencias.length > 0">
      <!-- <v-data-table
        :headers="headers"
        :items="monitorPendencias"
        :hide-default-footer="true"
        :disable-pagination="true"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.empresa }}</td>
            <td>{{ item.dataVigenciaInicio }}</td>
            <td>{{ item.entidadeReferencia.value }}</td>
            <td>{{ item.departamento }}</td>
            <td v-for="(documento, i) in documentos" :key="i">
              {{ item.documentos[documento] }}
            </td>
            <td>{{ item.competencia }}</td>
          </tr>
        </template>
      </v-data-table> -->
    </div>
  </div>
</template>

<script>
import GrupoService from "@/common/services/http/grupo.service";
import MonitorService from "@/common/services/http/monitor.service";
import EmpresaService from "@/common/services/http/empresa.service";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import RelatorioService from "@/common/services/http/relatorio.service";

export default {
  data: () => ({
    filtro: {
      periodo: "",
      grupoID: 0,
      empresaID: null,
      listarApenasEmpresasVigentes: true,
    },
    cliente: {},
    usuario: {},
    tipoUsuario: {},
    loading: false,
    carregando: false,
    carregandoGrupos: false,
    pesquisado: false,
    rules: {
      required: (v) => !!v || "Obrigatório",
    },
    relatorioXls: {
      pendenciasExportar: [],
      nomeArquivo: "",
    },
    grupos: [],
    headers: [],
    periodos: [],
    monitorPendencias: [],
    status: {
      0: "Reprovado",
      1: "Aprovado",
      2: "Aguardando Arquivos",
      3: "Aguardando Aprovação",
    },
    documentos: [],
  }),
  components: {
    KTCodePreview,
  },
  methods: {
    async downloadRelatorio() {
      this.loading = true;

      this.relatorioXls = RelatorioService.relatorioMonitorPendenciasPeriodo(
        this.monitorPendencias,
        this.documentos
      );
      setTimeout(() => {
        this.loading = false;
        this.$refs["download-relatorio-monitor-pendencias"].$el.click();
      }, 1000);
    },
    async carregarGrupos() {
      this.carregandoGrupos = true;
      if (this.filtro.empresaID != null) {
        const result = await GrupoService.getGrupoByEmpresaID(
          this.filtro.empresaID
        );

        if (result.success) this.grupos = result.data;
      } else {
        const result = await GrupoService.getGrupoByClienteID(this.cliente.id);

        if (result.success) this.grupos = result.data;
      }

      this.carregandoGrupos = false;
    },

    async carregarMonitor() {
      try {
        this.relatorioXls = {
          pendenciasExportar: [],
          nomeArquivo: "",
        },
          this.carregando = true;
        this.monitorPendencias = [];
        let query = {
          empresaID: this.filtro.empresaID,
          listarApenasEmpresasVigentes: this.filtro.listarApenasEmpresasVigentes,
        };
        let result = await MonitorService.getMonitorPendenciasAgregada(
          this.filtro.grupoID,
          query
        );

        if (result.success) {
          this.monitorPendencias = result.data;

          this.headers = [
            { text: "Empresa", value: "empresa" },
            { text: "Inicio de Vigência", value: "dataVigenciaInicio" },
            {
              text: this.monitorPendencias[0].entidadeReferencia.key,
              value: "entidadeReferencia.value",
            }
          ];

          if (this.monitorPendencias[0].propriedadeSecundaria) {
            this.headers.push({
              text: this.monitorPendencias[0].propriedadeSecundaria.key,
              value: "propriedadeSecundaria.value",
            });
          }

          if (this.monitorPendencias[0].propriedadeTerciaria) {
            this.headers.push({
              text: this.monitorPendencias[0].propriedadeTerciaria.key,
              value: "propriedadeTerciaria.value",
            });
          }

          this.headers.push({ text: "Departamento", value: "departamento" });

          this.documentos = Object.keys(
            this.monitorPendencias.map((x) => x.documentos)[0]
          );

          this.documentos.forEach((x) => {
            this.headers.push({
              text: x,
              value: `documentos.${x}`,
              align: "center",
            });
          });
          this.carregando = false;
          this.pesquisado = true;
          this.downloadRelatorio();
        }
      } catch (e) {
        this.carregando = false;
        this.pesquisado = true;
        this.monitorPendencias = [];
      }
    },
  },
  async mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));

    if (
      JSON.parse(window.localStorage.getItem("usuario")).usuario != undefined
    ) {
      this.tipoUsuario = JSON.parse(
        window.localStorage.getItem("usuario")
      ).usuario.tipoUsuario;
    }

    if (this.tipoUsuario === 4) {
      let empresaUsuario = await EmpresaService.getEmpresaByUsuario(
        this.usuario.usuario.id
      );

      this.filtro.empresaID = empresaUsuario.data.empresaID;
    }

    await this.carregarGrupos();
  },
};
</script>
